import { render, staticRenderFns } from "./WikiPageKeyboardShortcutHelpModal.vue?vue&type=template&id=6320be86&scoped=true"
import script from "./WikiPageKeyboardShortcutHelpModal.vue?vue&type=script&lang=ts"
export * from "./WikiPageKeyboardShortcutHelpModal.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageKeyboardShortcutHelpModal.vue?vue&type=style&index=0&id=6320be86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320be86",
  null
  
)

export default component.exports